import { inject, NgModule } from '@angular/core';
import { CanActivateFn, Router, RouterModule, Routes } from '@angular/router';
import { ReviewerDashboardComponent } from './reviewer.component';
import { DashboardReviewerComponent } from './reviewer-dashboard/reviewer-dashboard.component';
import { ProfileModule } from './profile/profile.module';
import { MessagesComponent } from './messages/messages.component';
import { PastProjectsComponent } from './past-projects/past-projects.component';
import { ReviewerSettingComponent } from './reviewer-setting/reviewer-setting.component';
import { InvoiceGeneratorComponent } from './invoice-generator/invoice-generator.component';
import { JobModule } from './job/job.module';
import { StorageService } from '../../shared/services/storage.service';
import { constants } from '../../shared/constants/constants';

export const jobBoardGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  const selectedTenant = storageService.getTenant();
  if (selectedTenant?.firm?.isJobBoardEnabled && selectedTenant.reviewerStatus !== constants.userVerificationStatus.pendingAdminVerification) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};

let routes: Routes = [
  {
    path: '',
    component: ReviewerDashboardComponent,
    children: [

      {
        path: 'dashboard',
        component: DashboardReviewerComponent
      },
      {
        path: 'profile',
        loadChildren: () => ProfileModule
      },
      {
        path: 'messages',
        component: MessagesComponent
      },
      {
        path: 'past-projects',
        component: PastProjectsComponent
      },
      {
        path: 'settings',
        component: ReviewerSettingComponent
      },
      {
        path: 'timekeeping',
        component: InvoiceGeneratorComponent
      },
      {
        path: 'job',
        loadChildren: () => JobModule,
        canActivate: [jobBoardGuard]
      },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReviewerRoutingModule { }
